(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["navigation-groups"] && !Shopify.designMode) return;
  try {
    (function () {
  function init() {
    var header = document.querySelector('.sc-navigation-preview');
    if (!header || header.dataset.groupedNavReady) return;
    header.dataset.groupedNavReady = 'true';
    header.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-nav-toggle]');
      if (!trigger) return;
      event.preventDefault();
      var item = trigger.closest('[data-nav-item]');
      var opened = trigger.dataset.clickedOpen === 'true';
      header.querySelectorAll('[data-nav-item]').forEach(function (other) {
        other.classList.remove('is-open');
        var button = other.querySelector('[data-nav-toggle]');
        if (button) { button.setAttribute('aria-expanded','false'); delete button.dataset.clickedOpen; }
      });
      if (!opened) { item.classList.add('is-open'); trigger.setAttribute('aria-expanded','true'); trigger.dataset.clickedOpen = 'true'; }
      else trigger.blur();
    });
    function closeMenus() {
      header.querySelectorAll('[data-nav-item]').forEach(function (item) {
        item.classList.remove('is-open');
        var button = item.querySelector('[data-nav-toggle]');
        if (button) { button.setAttribute('aria-expanded','false'); delete button.dataset.clickedOpen; }
      });
    }
    document.addEventListener('click',function(event) { if (!header.contains(event.target)) { closeMenus(); if(header.contains(document.activeElement)) document.activeElement.blur(); } });
    header.addEventListener('keydown',function(event) {
      if(event.key !== 'Escape' || !event.target.closest('.site-header__nav')) return;
      var item=event.target.closest('[data-nav-item]');
      var trigger=item && item.querySelector('[data-nav-toggle]');
      if(trigger) trigger.focus();
      closeMenus();
      if(trigger) trigger.blur();
    });
    var overflow = header.querySelector('[data-nav-overflow-list]');
    if(overflow) {
      var enrich=function() {
        observer.disconnect();
        Array.from(overflow.children).forEach(function(row) {
          if(row.querySelector('details')) return;
          var anchor=row.querySelector('a');
          if(!anchor) return;
          var source=Array.from(header.querySelectorAll('.site-header__nav-list > [data-nav-item]')).find(function(item) {
            var link=item.querySelector(':scope > a');
            return link && link.href===anchor.href;
          });
          var groups=source && source.querySelector('.sc-menu-groups--grid');
          if(!groups) return;
          var details=document.createElement('details'); details.className='sc-overflow-details';
          var summary=document.createElement('summary'); summary.textContent=anchor.textContent;
          details.append(summary,groups.cloneNode(true)); row.replaceChildren(details);
        });
        observer.observe(overflow,{childList:true});
      };
      var observer=new MutationObserver(enrich); enrich();
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
